import { createSelector } from 'reselect';
import { VEHICLES_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectVehiclesDomain = state => state[VEHICLES_DOMAIN] || initialState;

export const selectVehicles = () => createSelector(selectVehiclesDomain, d => d.vehicles);

export const selectVehicle = id => {
  const selector = createSelector(
    selectVehiclesDomain,
    (_, props) => props?.vehicle_id || id,
    (domain, vehicleId) => {
      if (domain.vehiclesById[vehicleId]) {
        return domain.vehiclesById[vehicleId];
      }
      return null;
    },
  );

  // If id is provided, return the selector result immediately
  if (id !== undefined) {
    return state => selector(state, { vehicle_id: id });
  }

  // Otherwise return the selector for use with createStructuredSelector
  return selector;
};

export const selectVehicleCount = () => createSelector(selectVehiclesDomain, d => d.vehicleCount);

export const selectVehicleHistoryLogs = () => createSelector(selectVehiclesDomain, d => d.historyLogs);
export const selectFilterHistoryLogs = () => createSelector(selectVehiclesDomain, d => d.filterHistoryLogs);

export const selectVehiclePaginator = () => createSelector(selectVehiclesDomain, d => d.paginator);

export const selectVehiclePropertyNames = () => createSelector(selectVehiclesDomain, d => d.propertyNames);

export const selectVehicleFilter = () => createSelector(selectVehiclesDomain, d => d.filter);

export const selectFilterSingleValue = name =>
  createSelector(selectVehicleFilter, d => d?.properties?.find(f => f.key === name)?.value?.[0] ?? null);
export const selectFilterValues = name =>
  createSelector(selectVehicleFilter, d => d?.properties?.find(f => f.key === name)?.value ?? []);

export const selectNewVehicleValue = name => createSelector(selectVehiclesDomain, d => d.newVehicle[name]);
export const selectNewVehicle = () => createSelector(selectVehiclesDomain, d => d.newVehicle);
export const selectNewVehicleOptions = () => createSelector(selectVehiclesDomain, d => d.newVehicleOptions);

export const selectNewOrderValue = name => createSelector(selectVehiclesDomain, d => d.newOrder[name]);
export const selectNewOrder = () => createSelector(selectVehiclesDomain, d => d.newOrder);

export const selectMMT = () => createSelector(selectVehiclesDomain, d => d.mmt);

export const selectAllOptions = () => createSelector(selectVehiclesDomain, d => d.allOptions);

export const selectOutgoingBpmCalculation = () => createSelector(selectVehiclesDomain, d => d.outgoingBpmCalculation);
export const selectHexonWebsites = () => createSelector(selectVehiclesDomain, d => d.hexonWebsites);

export const selectHexonAdsFor = vehicle_id => createSelector(selectVehiclesDomain, d => d.hexonAds[vehicle_id]);
export const selectHexonImagesFor = vehicle_id => createSelector(selectVehiclesDomain, d => d.hexonImages[vehicle_id]);

export const selectVehicleProperty = (vehicleId, propertyName) =>
  createSelector(selectVehiclesDomain, d => d.vehicleProperties[vehicleId]?.[propertyName]);

export const selectVehicleBulkActionsList = () => createSelector(selectVehiclesDomain, d => d.vehicleBulkActionsList);
export const selectVehicleBulkActionsKanbanTaskName = () => createSelector(selectVehiclesDomain, d => d.bulkActionTask);

export const selectVehicleTasks = () => createSelector(selectVehiclesDomain, d => d.vehicleTasks);
export const selectSilverdatData = id => createSelector(selectVehiclesDomain, d => d.silverdatData[id]);

export const selectVehicleHemexStatus = vehicleId => createSelector(selectVehiclesDomain, d => d.hemexStatus[vehicleId]);

export const selectVehiclesDocs = () => createSelector(selectVehiclesDomain, d => d.documents);
export const selectVehicleDocs = id => createSelector(selectVehiclesDomain, d => d.documents[id]);
